import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getCartVouchers from 'store/cart/selector/getCartVouchers';
import NumberOfAppliedVouchers from '../NumberOfAppliedVouchers/NumberOfAppliedVouchers';
import VoucherAddForm from '../VoucherAddForm/VouchersAddForm';
import VouchersList from '../VouchersList/VouchersList';
import styles from './Vouchers.module.scss';

interface VouchersListProps {
  onApplyVoucher: (voucherCode: string) => void;
  onRemoveVoucher: (voucherId: string) => void;
}

const Vouchers: React.FC<VouchersListProps> = ({ onApplyVoucher, onRemoveVoucher }) => {
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const vouchers = useSelector(getCartVouchers);
  const { t } = useTranslation();
  const tooManyVouchers = vouchers.length > 3;

  const toggleShowMore = () => {
    setShowMoreInfo((prev) => !prev);
  };

  return (
    <div className={styles.voucherSection}>
      <div className={styles.voucherWelcome} onClick={toggleShowMore}>
        <OpText variant="body" size="medium">
          <OpIcon icon="voucher" size="small" />
          {t('txt_got_voucher_code')}
        </OpText>
        <NumberOfAppliedVouchers vouchers={vouchers} />
      </div>
      {showMoreInfo && <VoucherAddForm onApplyVoucher={onApplyVoucher} />}
      {!tooManyVouchers || showMoreInfo ? <VouchersList onRemoveVoucher={onRemoveVoucher} vouchers={vouchers} /> : ''}
    </div>
  );
};

export default Vouchers;
